import { InteractionStatus } from "@azure/msal-browser";
import { ThemeProvider } from "@mui/material/styles";
import { Box, CircularProgress, CssBaseline } from "@mui/material";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { theme } from "./theme";
import AppContent from "./components/AppContent";
import LoginPage from "./components/LoginPage/LoginPage";
import { useAuth } from "./hooks/useAuth";

export default function App() {
  const { isAuthenticated, user, signIn, signOut, inProgress, loginInProgress } = useAuth();
  const msalBusy =
    inProgress !== InteractionStatus.None &&
    inProgress !== InteractionStatus.Logout;

  const styles = {
    loadingContainer: {
      width: "100vw",
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  };

  if (msalBusy) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {loginInProgress ? (
          <LoginPage loading />
        ) : (
          <Box sx={styles.loadingContainer}>
            <CircularProgress />
          </Box>
        )}
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <LoginPage onSignIn={signIn} />
              )
            }
          />
          <Route
            path="/*"
            element={
              isAuthenticated ? (
                <AppContent signOut={signOut} user={user} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
